import { http } from '@pendo/http';

export function getAutoProvisionFlagDisabledTooltip (type) {
    return {
        content: `${type} set via auto-provisioning and cannot be changed while auto-provisioning is enabled.`,
        multiline: true,
        arrow: true,
    };
}

export async function setMauLimit ({ mauLimit, subId }) {
    return http.put(`/api/super/s/${subId}/productline/core/metadata`, {
        mauLimit,
    });
}

export async function setAgentAnalyticsPromptLimits ({ monthlyPromptLimit, hourlyPromptLimit, subId }) {
    return http.put(`/api/super/s/${subId}/productline/agentAnalytics/metadata`, {
        monthlyPromptLimit,
        hourlyPromptLimit,
    });
}

export async function getAiBusinessContext ({ type = 'Subscription', id = '', subId = '_SID_' }) {
    return http
        .get(`/api/s/${subId}/businessContext/${type}/${id}`)
        .then((response) => response?.data || [])
        .catch((error) => {
            throw error;
        });
}

export async function getAiBusinessContextByType ({ type = 'Subscription', subId = '_SID_' }) {
    return http
        .get(`/api/s/${subId}/businessContext/${type}`)
        .then((response) => response?.data || [])
        .catch((error) => {
            throw error;
        });
}

export async function setAiBusinessContext ({ type = 'Subscription', id, subId = '_SID_', data }) {
    return http
        .post(`/api/s/${subId}/businessContext`, {
            type,
            parentId: id,
            formData: {
                body: data,
            },
        })
        .then(({ data }) => data)
        .catch((error) => {
            throw error;
        });
}

export async function updateAiBusinessContext ({ type = 'Subscription', id, subId = '_SID_', data }) {
    return http
        .patch(`/api/s/${subId}/businessContext/${type}/${id}`, {
            formData: {
                body: data,
            },
        })
        .then(({ data }) => data)
        .catch((error) => {
            throw error;
        });
}

export async function assessBusinessContextQuality ({ subId = '_SID_', data }) {
    return http
        .post(`/api/s/${subId}/businessContext/assessQuality`, data)
        .then(({ data }) => data)
        .catch((error) => {
            throw error;
        });
}

export const PENDO_INTERNAL_SUB_ID = '5668600916475904';

export const FY25_MODEL_STRING = 'FY25 Platform and Modules';

/**
 * Handles common side effects for flag changes across subscription settings
 * @param {Object} params
 * @param {string} params.flag - The flag being changed
 * @param {boolean} params.value - The new value of the flag
 * @param {Function} params.handleFlagChange - Recursive handler for dependent flags
 * @param {Function} params.setCollaborationInitialized - Mutation for veltIntegration
 */
export async function handleFlagSideEffects ({ flag, value, handleFlagChange, setCollaborationInitialized }) {
    if (flag === 'pendoFree') {
        await handleFlagChange({ flag: 'enableWebHooks', value: !value });
    }

    if (flag === 'veltIntegration') {
        if (value) {
            window.location.reload();
        } else {
            setCollaborationInitialized({ initialized: false });
        }
    }

    if (flag === 'replayAiSummary') {
        window.pendo.track('Enabled Replay AI Summary', { enabled: value });
    }
}

export const DEFAULT_MIN_SEGMENT_SIZE = 5;

export const MIN_SEGMENT_SIZE_FLOOR = 1;

export const MIN_SEGMENT_SIZE_CEILING = 500;
